<!--suppress ALL -->
<template>
  <div>

    <div class="" v-if="isItDevEnv">
      <go-collapse title="1. Infos Debug pour développement (sur serveur dev uniquement)" :open="false" :done="true">
      isGuidNull = {{isGuidNull}}<br>
      guid = {{guid}}<br>
      isDemandeInitialeROLoaded = {{isDemandeInitialeROLoaded}}<br>
      isDemandeAlreadysaved = {{isDemandeAlreadysaved}}<br>
      isIdDemandeValid = {{isIdDemandeValid}}<br>
      isGuidValid = {{isGuidValid}}<br>
      isSubmitToLocalDatabaseSuccessfull = {{isSubmitToLocalDatabaseSuccessfull}}<br>
      <p v-if="isDemandeInitialeROLoaded">guid effectif : [{{demandeDataEnCours.realGuid}}] créé le : {{demandeInitialeRO.datecreated}}</p>
      <pre ref="jsonDemandeDataEnCours"></pre>
      </go-collapse>
    </div>

    <p v-if="!isDemandeInitialeROLoaded && !isGuidNull">Veuillez patienter, récupération de la demande numéro : {{guid}}</p>
    <div v-if="!isGuidValid && !isGuidNull" class="alert alert-danger" role="alert"><p>{{demandeDataEnCours.realGuid}}</p></div>
    <div v-if="isSavingError" class="alert alert-danger" role="alert">
      <p>{{lastSavingError}}</p>
    </div>

    <!--
    <p v-if="isItDevEnv">{{data_json}}</p>
    -->


    <div id="questions" v-show="isIdDemandeValid && isSubmitToLocalDatabaseSuccessfull">

      <go-collapse :title="step2Msg" :open="true" :done="demandeDataEnCours.step2IsDone">
          <div class="form-group col-md-6">
            <h4>{{demandeInitialeRO.id}}/{{streetName}}</h4>
            <h4>{{demandeInitialeRO.nomAffaire | capitalize}}</h4>
            <p>
              Le surveillant de la Ville en charge de l'affaire est :
              <strong>M.{{demandeInitialeRO.responsableVdL}}</strong>
            </p>
            <h5 v-if="demandeInitialeRO.itWasUnAuthorizedOccupacy">
              <strong>il s'agit d'une demande effectuée suite à une occupation non autorisée</strong>
            </h5>
            <h5 v-if="demandeInitialeRO.BPayant">Ce permis sera <strong>payant</strong></h5>
            <h5 v-else>Ce permis sera gratuit</h5>
            <div v-if="isDemandeInitialeROLoaded">
              <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.Mandataire">
              </go-collapse-acteur-role-details>
              <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.Beneficiaire">
              </go-collapse-acteur-role-details>
              <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.MaitreOuvrage">
                Affaire Coordination : {{demandeInitialeRO.IdAffCoordChantier}} / {{demandeInitialeRO.nomAffCoordChantier}}
              </go-collapse-acteur-role-details>
              <hr>
            </div>
          </div>
          <div class="form-group col-md-6">
            <fieldset><legend>Vos informations de contact </legend>
              <div class="form-group">
                <label>Nom :</label>{{demandeDataEnCours.affClientContact}}
              </div>
              <div class="form-group">
                <label>Votre email :</label>{{demandeDataEnCours.affClientEmail}}
                <span id="helpBlockaffClientEmail" class="help-block">Le permis sera envoyé à cette adresse mail !</span>
              </div>
              <div class="form-group">
                <label>Tel :</label>{{demandeDataEnCours.affClientTelephone}}
              </div>
            </fieldset>
            <!-- supprime demande DESMET juin 2023
                     <template v-if="demandeDataEnCours.IsContactPoliceDone">
                       <label>Vous avez déjà pris contact avec M. {{demandeDataEnCours.responsablePolice}} de la police.</label>
                       <template v-if="demandeDataEnCours.responsablePolice !== null">
                         <div class="alert alert-info" role="alert">
                           <p>Le requérant demeure seul responsable envers la Commune de Lausanne du respect des
                           <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public/domaine-public-conditions-d-usage-du-domaine-public.html">
                             conditions d'usage du domaine public
                           </a>
                           ou d'un bien fonds qui lui est assimilé.
                           </p>
                           <p>
                           En cochant la case ci-dessous, il certifie les avoir lues et accepte les suites pénales
                           ou juridiques en cas d'accident.
                           Le présent formulaire, les conditions d'usage du domaine public,
                           ainsi que les tarifs en vigueur, peuvent être obtenus sur le présent site Internet:
                           <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html">
                           www.lausanne.ch/domaine_public</a>
                           </p>
                           <template v-if="demandeDataEnCours.IsConditionGeneralAccepted">
                             <strong>Vous avez acceptez les
                               <a href="http://www.lausanne.ch/domaine_public">
                               conditions générales de l'utilisation temporaire du DP.
                               </a>
                             </strong>
                           </template>
                           <template v-if="!demandeDataEnCours.IsConditionGeneralAccepted">
                             <strong>Vous n'avez pas acceptez les
                               <a href="http://www.lausanne.ch/domaine_public">
                               conditions générales de l'utilisation temporaire du DP.
                               </a>
                             </strong>
                           </template>
                         </div>
                       </template>
                     </template>
                     -->
          </div>
      </go-collapse>

      <go-collapse :title="step4Msg" :open="true" @gocollapseOpen="adjustMap"
                   :disabled="false" :done="demandeDataEnCours.step4IsDone">
        <form id="goform-step4" action="#">
          <div class="form-group col-md-12">
            <h4>plan du perimetre du chantier</h4>
            <p v-if="isPolygonAlreadyPresentInGoeland">ce perimetre du chantier provient de la coordination de chantier VdL (il existe déjà goéland) on peut juste le visualiser.</p>
            <p v-if="!isPolygonAlreadyPresentInGoeland">Vous avez créé le(s) polygone(S) de l'emprise de votre demande sur le DP</p>
            <div v-if="showMap">
            <cgil-ol-map style="height: 800px; width: 100%" ref="mapchantier"
                         :edit-geom-enabled="false"
                         :layers-config="mapLayers"
                         :geomGeoJSON="demandeInitialeRO.geomAffCoordChantier"
                         :geomWkt="geometrieChantiersSaisiePrecedement"
                         @gomapSaveGeomClick="saveGeometry"
            ></cgil-ol-map>
            </div>
          </div>
        <div class="form-group col-md-6">
          <div class="">
            <label for="commentaireLocalisation" class="control-label">Commentaire : {{demandeDataEnCours.commentaireLocalisation}}</label>
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="">
            <label for="descriptionTravaux" class="control-label">Description des travaux: {{demandeDataEnCours.descriptionTravaux}}</label>
          </div>

        </div>
          <div id="divDatBegin" class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                Date de Début : {{demandeDataEnCours.dateDebutOccupation | dateformat}}
              </label>
            </div>
          </div>
          <div id="divDateEnd" class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                Date de Fin : {{demandeDataEnCours.dateFinOccupation | dateformat}}
              </label>
            </div>
          </div>

        </form>

      </go-collapse>

      <go-collapse :title="step5Msg" :open="true" :disabled="false" :done="demandeDataEnCours.step5IsDone">
        <div class="row">
          <div class="col-sm-12">
            <label v-if="demandeDataEnCours.isFouilleOuForage">Vous allez effectuer des fouilles et/ou des forages sur le DP </label>
            <label v-if="!demandeDataEnCours.isFouilleOuForage">Vous n'allez pas effectuer des fouilles et/ou des forages sur le DP </label>
          </div>
        </div>
        <hr>
        <div class="row" v-if="demandeDataEnCours.isFouilleOuForage">
          <div class="col-sm-12">
            <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 1 :</legend>
              <div class="row">
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLongueur01" placeholder="Longueur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLongueur01">
                </div>
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLargeur01" placeholder="Largeur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLargeur01">
                </div>
                <div class="col-sm-4">Surface = <span class="pull-right">{{ demandeDataEnCours.fouilleSurface01 }}  m²</span></div>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-12">
            <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 2 :</legend>
              <div class="row">
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLongueur02" placeholder="Longueur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLongueur02">
                </div>
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLargeur02" placeholder="Largeur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLargeur02">
                </div>
                <div class="col-sm-4">Surface = <span class="pull-right">{{ demandeDataEnCours.fouilleSurface02 }}  m²</span></div>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-12">
            <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 3 :</legend>
              <div class="row">
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLongueur03" placeholder="Longueur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLongueur03">
                </div>
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLargeur03" placeholder="Largeur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLargeur03">
                </div>
                <div class="col-sm-4">Surface = <span class="pull-right">{{ demandeDataEnCours.fouilleSurface03 }}  m²</span></div>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-12">
            <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 4 :</legend>
              <div class="row">
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLongueur04" placeholder="Longueur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLongueur04">
                </div>
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLargeur04" placeholder="Largeur en m" readonly disabled
                         v-model="demandeDataEnCours.fouilleLargeur04">
                </div>
                <div class="col-sm-4">Surface = <span class="pull-right">{{ demandeDataEnCours.fouilleSurface04 }}  m²</span></div>
              </div>
            </fieldset>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <h4 class="pull-right">Surface Totale = &nbsp;<span class="pull-right">{{ demandeDataEnCours.fouilleSurfaceTotal }}  m²</span></h4>
            </div>
          </div>
          <div class="col-sm-12">
            <div id="divDatBegin" class="col-sm-6">
              <div class="form-group">
                <label class="control-label">
                  Date de Début : {{demandeDataEnCours.fouilleDateDebut | dateformat}}
                </label>
              </div>
            </div>
            <div id="divDateEnd" class="col-sm-6">
              <div class="form-group">
                <label class="control-label">
                  Date de Fin : {{demandeDataEnCours.fouilleDateFin | dateformat}}
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <label v-if="demandeDataEnCours.isFouilleSurChaussee">Les travaux se situent sur la chaussée.</label>
            <label v-if="!demandeDataEnCours.isFouilleSurChaussee">Les travaux ne se situent pas sur la chaussée.</label>
          </div>
          <div class="col-sm-6">
            <label v-if="demandeDataEnCours.isFouilleSurTrotoir">Les travaux se situent sur un trottoir.</label>
            <label v-if="!demandeDataEnCours.isFouilleSurTrotoir">Les travaux ne se situent pas sur un trottoir.</label>
          </div>
          <div class="col-sm-6">
            <label v-if="demandeDataEnCours.isFouilleEndomageBalisageSol">Les travaux endommageront le balisage au sol.</label>
            <label v-if="!demandeDataEnCours.isFouilleEndomageBalisageSol">Les travaux n'endommageront pas le balisage au sol.</label>
          </div>
          <div class="col-sm-6">
            <label v-if="demandeDataEnCours.isFouilleSurZonePavee">Les travaux se situent sur une zone pavée.</label>
            <label v-if="!demandeDataEnCours.isFouilleSurZonePavee">Les travaux ne se situent pas sur une zone pavée.</label>
          </div>
          <!-- supprime demande DESMET juin 2023
       <div class="col-sm-6" v-if="demandeDataEnCours.isFouilleSurZonePavee">
         <label v-if="demandeDataEnCours.isFouilleSurZonePaveeDevisDemande">
           Vous souhaitez nous mandater la réfection du pavage au tarif ci-dessous</label>
         <div class="col-sm-12" v-if="demandeDataEnCours.isFouilleSurZonePaveeDevisDemande">
         <el-card class="box-card">
             <div slot="header" class="clearfix">
               <span><h4>Tarifs en vigueur (décembre 2018)</h4></span>
             </div>
             <div class="text item">
               <p>Prix : CHF 300.- au m2 (hors taxe), comprenant :</p>
               <ul>
                 <li>dégrapage et évacuation du revêtement provisoire</li>
                 <li>fourniture et mise en place de toutes les marchandises nécessaires</li>
                 <li>main-d'œuvre, machines et transports</li>
               </ul>
               <p>Cette prestation sera facturée en supplément du permis d'utilisation temporaire du domaine public.<br>
                 Pour plus de détails sur cette prestation, contactez
                 l'unité travaux du service des routes et de la mobilité<br></p>
                 <ul>
                   <li>Par téléphone :<a href="tel:+41213155491">+41 21 315 54 91</a></li>
                   <li>Par email : <a href="mailto:rmunitetravaux@lausanne.ch">rmunitetravaux@lausanne.ch</a></li>
                 </ul>

             </div>
           </el-card>
         </div>
         <label v-if="!demandeDataEnCours.isFouilleSurZonePaveeDevisDemande">
           Vous ne souhaitez pas nous mandater la réfection du pavage.</label>
       </div>
       -->
        </div>
      </go-collapse>

      <go-collapse :title="step6Msg" :open="true" :disabled="false" :done="demandeDataEnCours.step6IsDone">
        <label v-if="demandeDataEnCours.isOccupationDP">Vous allez occuper le DP avec :</label>
        <label v-if="!demandeDataEnCours.isOccupationDP">Vous n'allez pas occuper le DP.</label>
        <hr>
        <div class="form-group">
          <div class="col-sm-12">
            <fieldset class="fouille-fieldset"><legend class="fouille-legend">Taille occupation :</legend>
              <div class="row">
                <div class="col-sm-4">
                  <input type="number" min=0 id="occupationDPLongueur01" placeholder="Longueur en m" readonly disabled
                         v-model="demandeDataEnCours.occupationDPLongueur01">
                </div>
                <div class="col-sm-4">
                  <input type="number" min=0 id="occupationDPLargeur01" placeholder="Largeur en m" readonly disabled
                         v-model="demandeDataEnCours.occupationDPLargeur01">
                </div>
                <div class="col-sm-4">Surface = <span class="pull-right">{{ demandeDataEnCours.occupationDPSurface01 }}  m²</span></div>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row" v-if="demandeDataEnCours.isOccupationDP">
          <div class="form-group">
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_Benne">
              <div class="checkbox goOccupationCheckbox">
                <label>Benne</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_DepotMateriel">
              <div class="checkbox goOccupationCheckbox">
                <label>Dépôt de matériel</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_DepotEnginsChantier">
              <div class="checkbox goOccupationCheckbox">
                <label>Dépôt d'engins de chantier</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_PalissadeOuClotureChantier">
              <div class="checkbox goOccupationCheckbox">
                <label>Palissade / Clôture de chantier</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_RoulotteOuContainer">
              <div class="checkbox goOccupationCheckbox">
                <label>Roulotte / Container de chantier</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_CamionNacelle">
              <div class="checkbox goOccupationCheckbox">
                <label>Camion nacelle</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_CamionGrue">
              <div class="checkbox goOccupationCheckbox">
                <label>Camion grue</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_Grue">
              <div class="checkbox goOccupationCheckbox">
                <label>Grue</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_ChauffageMobile">
              <div class="checkbox goOccupationCheckbox">
                <label>Chauffage mobile</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_Echafaudage">
              <div class="checkbox goOccupationCheckbox">
                <label>Echafaudage</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_ElagageArbre">
              <div class="checkbox goOccupationCheckbox">
                <label>Elagage d'arbre</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_Etayage">
              <div class="checkbox goOccupationCheckbox">
                <label>Etayage</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_PontRoulant">
              <div class="checkbox goOccupationCheckbox">
                <label>Pont roulant</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_AccesChantier">
              <div class="checkbox goOccupationCheckbox">
                <label>Accès chantier</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_GroupeElectrogene">
              <div class="checkbox goOccupationCheckbox">
                <label>Groupe électrogène</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne">
              <div class="checkbox goOccupationCheckbox">
                <label> Pose / dépose / modification d’enseigne ou de support d’affichage</label>
              </div>
            </div>
            <div class="col-sm-4" v-if="demandeDataEnCours.Occupation_Autre != null">
                <label for="Occupation_Autre">Autre : {{demandeDataEnCours.Occupation_Autre}}</label>
            </div>
          </div>

        </div>

      </go-collapse>

      <go-collapse :title="step7Msg" :open="true" :disabled="false" :done="demandeDataEnCours.step7IsDone">
        <div class="row">
          <div class="col-sm-12">
            <label v-if="demandeDataEnCours.isStationnementPresent">Vos travaux occuperonts des places de stationnement publiques.</label>
            <label v-if="!demandeDataEnCours.isStationnementPresent">Vos travaux n'occuperonts pas des places de stationnement publiques.</label>
          </div>
        </div>
        <hr>

        <div class="row" v-if="demandeDataEnCours.isStationnementPresent">
          <div class="col-sm-6">
            <div class="form-group">
              <label v-if="demandeDataEnCours.StationnementNumMacarons > 0" class="control-label">
                {{demandeDataEnCours.StationnementNumMacarons}} place(s) ouvertes aux macarons.
              </label>
            </div>
            <div id="divDateBeginStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumMacarons > 0">
              <div class="form-group">
                <label class="control-label">
                  Date de Début : {{demandeDataEnCours.StationnementNumMacarons_date_debut | dateformat}}
                </label>
              </div>
            </div>
            <div id="divDateEndStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumMacarons > 0">
              <div class="form-group">
                <label class="control-label">
                  Date de Fin : {{demandeDataEnCours.StationnementNumMacarons_date_fin | dateformat}}
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label v-if="demandeDataEnCours.StationnementNumAutres >0" class="control-label">
                {{demandeDataEnCours.StationnementNumAutres}} autres place(s).</label>
            </div>
            <div id="divDateBeginStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumAutres >0">
              <div class="form-group">
                <label class="control-label">
                  Date de Début : {{demandeDataEnCours.StationnementNumAutres_date_debut  | dateformat}}
                </label>
              </div>
            </div>
            <div id="divDateEndStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumAutres >0">
              <div class="form-group">
                <label class="control-label">
                  Date de Fin : {{demandeDataEnCours.StationnementNumAutres_date_fin  | dateformat}}
                </label>
              </div>
            </div>
          </div>
          <div id="divStationnementCommentaire"class="form-group col-sm-12">
                <div class="">
                  <label for="StationnementCommentaire" class="control-label">Commentaire : </label>
                </div>
                <div class="">
                  <textarea rows="3" id="StationnementCommentaire" v-model="demandeDataEnCours.StationnementCommentaire" type="text" class="form-control"/>
                </div>
          </div>
        </div>
      </go-collapse>
<!--
      <go-collapse :title="step8Msg" :open="demandeDataEnCours.step4IsDone && !demandeDataEnCours.step8IsDone"
                   :disabled="!isStep5Valid" :done="demandeDataEnCours.step8IsDone">
        <div class="alert alert-info" role="alert">
          <p>Le requérant demeure seul responsable envers la Commune de Lausanne du respect des
            <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public/domaine-public-conditions-d-usage-du-domaine-public.html">
              conditions d'usage du domaine public
            </a>
            ou d'un bien fonds qui lui est assimilé.
          </p>
          <p>
            En cochant la case ci-dessous, il certifie les avoir lues et accepte les suites pénales
            ou juridiques en cas d'accident.
            Le présent formulaire, les conditions d'usage du domaine public,
            ainsi que les tarifs en vigueur, peuvent être obtenus sur le présent site Internet:
            <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html">
              www.lausanne.ch/domaine_public</a>
          </p>
          <strong>Acceptez-vous les
            <a href="http://www.lausanne.ch/domaine_public">
              conditions générales de l'utilisation temporaire du DP ?
            </a>
          </strong>

          <go-switch v-model="demandeDataEnCours.IsConditionGeneralAccepted"></go-switch>

        </div>
      </go-collapse>
    -->

    </div><!-- FIN DE LA DIV  id="questions" v-show="isIdDemandeValid"> -->
    <div id="information" v-show="isIdDemandeValid && isSubmitToLocalDatabaseSuccessfull">

      <go-collapse :title="stepRequestSendedMsg" :open="isSubmitToLocalDatabaseSuccessfull"
                   :disabled="false" :done="isSubmitToLocalDatabaseSuccessfull">

      Madame, Monsieur,<br /><br />
      Votre demande de permis d'occupation temporaire du domaine public numéro {{demandeDataEnCours.id}}
      nous a été envoyée le {{demandeDataEnCours.datesubmited }} <br><br>
      Nous vous en remercions et vous informons que son traitement est en cours.<br>
      Une réponse de notre part vous parviendra, au plus tard, trois jours ouvrables avant la date d'occupation souhaitée.<br><br>

      Dans l'intervalle, nous vous adressons, Madame, Monsieur, nos cordiales salutations.<br /><br /><br />
      <small><b>Ville de Lausanne</b> | service des routes et de la mobilité | surveillance du domaine public</small><br />
      <small>rue du Vallon 27 | 1005 Lausanne | T +41 21 315 5412 ou 5472 ou 5262  | <a href='http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html'>web</a></small>
      </go-collapse>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import vSelect from 'vue-select'
  import goCollapse from './ui/goCollapse'
  import goSwitch from './ui/goSwitch.vue'
  import {BASE_REST_API_URL, DEV, getLog} from './config'
  import {demandePoDP} from './demandePoDP'
  import goSelectActeur from './geo/goSelectActeur.vue'
  import {functionExist, isNullOrUndefined, getStringParam} from 'cgil-html-utils'
  import goCollapseActeurRoleDetails from './ui/goCollapseActeurRoleDetails.vue'
  import cgilOlMap from './cgil-vue-olmap/cgil-vue-olmap'
  import './cgil-vue-olmap/ol.css'
  import { hexToArr } from './cgil-vue-olmap/tools'
  import Datepicker from 'vuejs-datepicker'

  const log = getLog('goelandViewPODP', 4, 1)

  const pos = [538127.1, 151624.1] // Av Acacacias Lausanne
  // const pos = [538350.5, 152669.0] // cathedrale Lausanne
  const baseLayerSelected = getStringParam('baselayer', 'fonds_geo_osm_bdcad_gris')
  const layersVisibility = getStringParam('lvisibles', '41')
  const arrLayersVisibility = hexToArr(`0x${layersVisibility}`)
  log.w(`layersVisibility:${layersVisibility} => arrLayersVisibility: ${arrLayersVisibility}`)

  export default {
    name: 'goelandViewPodp',
    components: {
      cgilOlMap,
      goSwitch,
      vSelect,
      goCollapse,
      goCollapseActeurRoleDetails,
      goSelectActeur,
      Datepicker
    },
    props: {
      guid: {
        type: String,
        default: null
      }
    },
    data: function () {
      return {
        isItDevEnv: DEV,
        center: pos,
        isGuidNull: null,
        data_json: null, // Ref sur le contenu de la demande distante initiale provenant de la db goeland
        // GESTION DES ETATS DE CHARGEMENTS
        isDemandeInitialeROLoaded: false, // chargement des donnees initiales distante data_json initiale est-il termine
        isIdDemandeValid: true,
        isDemandeAlreadysaved: null, // est-ce que la demande en cours contient deja des données ?
        isdemandeDataEnCoursLoaded: false, // est-ce que les données de la demande en cours sont chargées ?
        isSubmitToLocalDatabaseSuccessfull: false, // on a envoye le formulaire et il est sauve dans la BD  postgresql locale
        isGuidValid: null,
        // GESTION ERREUR SAUVEGARDE
        isSavingError: false,
        lastSavingError: '',
        goodStreetIds: [], // pour stocker ids des rues du chantier pour controle securite
        step1Msg: '1. identification',
        // une fois que l'utilisateur indique au moins une rue en relation avec cette demande
        // on considere cette etape 1 d'identification  comme terminee et on passe a la suivante
        step1IsDone: true,
        step2Msg: '1. informations générales',
        /* dans cette etape on affice les informations en lecture uniquement de la demande initiale
         on verifie dans la BD locale si un debut de demande existe si c'est le cas on rafraichi les donnee
         si ce ne'est pas le cas alors l'utilisateur doit :
                 a) [IsContactPoliceDone] : confirmer qu'il a pris contact avec la police
                 b) responsablePolice : indiquer le responsable police avec qui il a discuté
                 c) IsConditionGeneralAccepted: confirmer qu'il accepte les Conditions generales
            une fois que ces 3 conditions sont remplies l'Etape 2 est terminee [step2IsDone=true]
            on sauve l'etat de la demande en cours demandeDataEnCours
         */

        step2arrContactPolice: ['Frédéric Vauthey', 'Martial Maillard', 'Anouk Louvet-Jardin'],
        step3Msg: '3. Interlocuteurs',
        step3arrActeurFacturationOptions: [
          'Bénéficiaire du permis',
          'Maitre d\'ouvrage',
          'Mandataire',
          'Autre'
        ],
        step4Msg: '2. localisation',
        showMap: true,
        isPolygonAlreadyPresentInGoeland: null,
        dateDebutDisabled: {to: null, from: null},
        dateFinDisabled: {to: null, from: null},
        datePickerHighlighted: {to: null, from: null},
        step5Msg: '3. fouilles',
        step6Msg: '4. occupation',
        step7Msg: '5. places de stationnement',
        // pour les controles datepicker min max
        dateDebutDisabled_StationnementNumMacarons: {to: null, from: null},
        dateFinDisabled_StationnementNumMacarons: {to: null, from: null},
        datePickerHighlighted_StationnementNumMacarons: {to: null, from: null},
        dateDebutDisabled_StationnementNumAutres: {to: null, from: null},
        dateFinDisabled_StationnementNumAutres: {to: null, from: null},
        datePickerHighlighted_StationnementNumAutres: {to: null, from: null},
        step8Msg: '8. Envoyer la demande',
        stepRequestSendedMsg: 'Votre demande a été envoyée',
        idDemande: null, // pour permetre evt saisie manuelle id affaire (securite)
        streetSelected: null, // pour stocker rue selectionne par utilisateur (securite)
        streetName: '',
        streetList: [],
        geometrieChantiersSaisiePrecedement: '',
        // ############ informations initiales recues via Goeland sur cette demande
        demandeInitialeRO: {
          id: 0, // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
          nomAffaire: null, // NEW data_json["NomAffaire"] titre affaire goéland
          datecreated: null, // date de creation des donnees distante demande initiale
          responsableVdL: null, //  data_json["ResponsableVdL"] le user qui saisit la demande
          itWasUnAuthorizedOccupacy: null, // data_json["BRegularisation"] s'agit itl d'une regularisation
          BPayant: null, // data_json["BPayant"] le permis est payant
          // infos provenant de coordination chantier
          IdAffCoordChantier: null, // data_json["IdAffCoordChantier"]
          nomAffCoordChantier: null, // data_json["NomAffCoordChantier"]
          UOLeaderAffCoordChantier: null, // data_json["UOLeaderAffCoordChantier"]
          geomAffCoordChantier: null, // data_json["GeomAffCoordChantier"]
          // infos concernant les acteurs liés reçus data_json["ActeurL": [{...}]
          // on doit recevoir au moins 1 entree dans ActeurL
          isBeneficiaireGiven: false,
          isMandataireGiven: false,
          Beneficiaire: {
            idActeur: null,
            Role: null,
            Nom: null,
            AdresseCorresp: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          Mandataire: {
            idActeur: null,
            Role: null,
            Nom: null,
            AdresseCorresp: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          // cas du IdAffCoordChantier et UOLeaderAffCoordChantier non null du coup c'est eux le Maitre Ouvrage
          isMaitreOuvrageGiven: false,
          MaitreOuvrage: {
            Role: null,
            Nom: null
          }
        },

        // ############ informations saisie par le client concernant cette demande qui sera renvoyée plus loin
        demandeDataEnCours: {
          // **** infos identifiant la demande initiale
          id: null,   // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
          guid: null,  // READONLY  guid demande initiale passee dans url
          realGuid: null,  // READONLY dernier (temporellement) guid reel utilise pour la demande distante
          // **** infos geree par le systeme
          datecreated: null, // date premiere sauvegarde de cette demande cote client
          datelastmodif: null, // date derniere modification de cette demande cote client
          datesubmited: null,  // date de bouclement (submit final) de cette demande cote client
          // **** infos concernant Etape 2 de la demande cote client
          affClientContact: null, // data_json["AffClientContact"]
          affClientEmail: null, // data_json["AffClientEmail"]
          affClientTelephone: null, // data_json["AffClientTelephone"]
          IsContactPoliceDone: false,
          responsablePolice: null, // string
          IsConditionGeneralAccepted: false,
          step2IsDone: false,
          // **** infos concernant Etape 3 de la demande cote client
          acteurBeneficiaire: {
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          acteurMaitreOuvrage: {
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          acteurMandataire: {
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          isActeurFacturationOneOfPrevious: true,
          acteurFacturationOptionSelected: 'Bénéficiaire du permis', // TODO la valeur par defaut s'affiche pas
          acteurFacturation: {
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          step3IsDone: false,
          // **** infos concernant Etape 4 de la demande cote client
          // ici on rappelle les rues et les adresses concernées
          commentaireLocalisation: null, // Commentaire sur la localisation
          descriptionTravaux: null,  // [string] champ libre
          dateDebutOccupation: null, // [date] limiter date maintenant moins n mois
          dateFinOccupation: null,   // [date] doit etre plus grand que debut et minumum 10 jours
          //  En cas de prolongation du chantier, veuillez nous transmettre une copie du permis délivré avec l'indication des nouvelles dates, ceci avant son échéance.
          step4IsDone: false,
          geometrieChantiersSaisie: null, // saisie de la geometrie
          // ** Utilisation du domaine public pour une fouille
          isFouilleOuForage: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
          // debut ajout champs pour demande DESMET juin 2023
          fouilleLongueur01: 0,    // [Number] Longueur fouille
          fouilleLargeur01: 0,    // [Number] Largeur fouille
          fouilleSurface01: 0,    // [Number] Surface fouille
          fouilleLongueur02: 0,
          fouilleLargeur02: 0,
          fouilleSurface02: 0,
          fouilleLongueur03: 0,
          fouilleLargeur03: 0,
          fouilleSurface03: 0,
          fouilleLongueur04: 0,
          fouilleLargeur04: 0,
          fouilleSurface04: 0,
          fouilleSurfaceTotal: 0,
          fouilleDateDebut: null,
          fouilleDateFin: null,
          // fin ajout champs pour demande DESMET juin 2023
          isFouilleSurChaussee: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
          isFouilleSurTrotoir: false, // [Boolean] les travaux se situent-ils sur un trottoir ?
          isFouilleSurZonePavee: false,
          isFouilleSurZonePaveeDevisDemande: false,
          isFouilleEndomageBalisageSol: false, // [Boolean] les travaux endommageront-ils le balisage au sol ?
          step5IsDone: false,
          // ** Occupation du domaine public
          isOccupationDP: false,
          // debut ajout champs pour demande DESMET juin 2023
          occupationDPLongueur01: 0,
          occupationDPLargeur01: 0,
          occupationDPSurface01: 0,
          isOccupation_PoseDeposeModificationEnseigne: false,
          // fin ajout champs pour demande DESMET juin 2023
          isOccupation_Benne: false,
          isOccupation_DepotMateriel: false,
          isOccupation_DepotEnginsChantier: false,
          isOccupation_PalissadeOuClotureChantier: false, // palissade / clôture de chantier
          isOccupation_RoulotteOuContainer: false,  //       roulotte / container de chantier
          isOccupation_CamionNacelle: false,  //             camion nacelle
          isOccupation_CamionGrue: false,  //         camion grue
          isOccupation_Grue: false,  //               grue
          isOccupation_ChauffageMobile: false,  //    chauffage mobile
          isOccupation_Echafaudage: false,  //        échafaudage
          isOccupation_ElagageArbre: false,  //       élagage d'arbre
          isOccupation_Etayage: false,  //           étayage
          isOccupation_PontRoulant: false,  //        pont roulant
          isOccupation_GroupeElectrogene: false,  //        groupe électogène (ajout 2022)
          isOccupation_AccesChantier: false,  //      accès chantier
          isOccupation_Autre: false,  //      Autre
          Occupation_Autre: null,
          step6IsDone: false,
          isStationnementPresent: false,
          StationnementCommentaire: null,
          StationnementNumMacarons: 0,
          StationnementNumMacarons_date_debut: null,
          StationnementNumMacarons_date_fin: null,
          StationnementNumAutres: 0,
          StationnementNumAutres_date_debut: null,
          StationnementNumAutres_date_fin: null,
          step7IsDone: false,
          step8IsDone: false,
          isFinalSubmitDone: false  // c'est ici que l'on va garde l'info si l'envoi definitif est fait
        },
        mapLayers: {
          baseLayer: baseLayerSelected,
          layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
          wmsLayers: [
            {
              layers: 'bdcad_projets_msgroup',
              title: 'Projets et chantiers',
              isVisible: arrLayersVisibility[0]
            },
            {
              layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
              title: 'PFP',
              isVisible: arrLayersVisibility[1]
            },
            {
              layers: 'bdcad_pfp_reperage_msgroup',
              title: 'PFP repérage',
              isVisible: arrLayersVisibility[2]
            },
            {
              layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
              title: 'PFA',
              isVisible: arrLayersVisibility[3]
            },
            { // je choisis la version du GC public pour que cela fonctionne partout
              layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
              title: 'Arbres',
              isVisible: arrLayersVisibility[4]
            },
            {
              layers: 'envconst_toitures_veg',
              title: 'Toitures Végétalisées',
              isVisible: arrLayersVisibility[5]
            },
            /* // pas disponible sur map :
            {
              layers: 'bdcad_bf_parcom_pol',
              title: 'Parcelles Communales',
              isVisible: arrLayersVisibility[6],
            },
               */
            {
              layers: 'perimetres_lim_com_msgroup',
              title: 'Limites Communales',
              isVisible: arrLayersVisibility[6]
            },
            {
              layers: 'altimetrie_hauteur_vegetation_mnc_class',
              title: 'Canopée végétation',
              isVisible: arrLayersVisibility[7]
            }
          ]
        } // FIN DE LA CONFIG DES mapLayers
      }
    }, // end of data section
    computed: {
      isStep2Valid: function () {
        if (!this.isSubmitToLocalDatabaseSuccessfull) {
          if (this.isIdDemandeValid && this.demandeDataEnCours.IsContactPoliceDone &&
            this.demandeDataEnCours.IsConditionGeneralAccepted) {
            this.demandeDataEnCours.step2IsDone = true
            return true
          } else {
            this.demandeDataEnCours.step2IsDone = false
            return false
          }
        }
      },
      isStep3Valid: function () {
        if (!this.isSubmitToLocalDatabaseSuccessfull) {
          /* TODO ici il faut toujours acteurBeneficiaire complet
            et idéalement au moins un des deux suivants acteurMaitreOuvrage ou acteurMandataire
        */
          if (this.demandeDataEnCours.acteurBeneficiaire.isActeurValid &&
            this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid) {
            this.demandeDataEnCours.step3IsDone = true
            return true
          } else {
            this.demandeDataEnCours.step3IsDone = false
            return false
          }
        }
      },
      isStep4Valid: function () {
        if (!this.isSubmitToLocalDatabaseSuccessfull) {
          if (this.demandeDataEnCours.dateDebutOccupation !== null &&
            this.demandeDataEnCours.dateFinOccupation !== null &&
            this.demandeDataEnCours.descriptionTravaux !== null) {
            this.demandeDataEnCours.step4IsDone = true
            this.saveForm()
            return true
          } else {
            this.demandeDataEnCours.step4IsDone = false
            return false
          }
        }
      },
      // Fouilles sur DP
      isStep5Valid: function () {
        return true // en attendant d'avoir des infos de validation plus precise ...
      },
      // Occupation du DP
      isStep6Valid: function () {
        return true // en attendant d'avoir des infos de validation plus precise ...
      },
      // Utilisation de Places de Stationnement
      isStep7Valid: function () {
        return true // en attendant d'avoir des infos de validation plus precise ...
      },
      isFormValid: function () {
        if (this.isStep2Valid && this.isStep3Valid &&
          this.isStep4Valid && this.isStep5Valid &&
          this.isStep6Valid && this.isStep7Valid) {
          return true
        } else {
          return false
        }
      }

    }, // end of computed props section

    watch: {
      '$route' (to, from) {
        log.w('## IN viewPoDP.watch($route) ', to, from)
        if (to.params.guid !== from.params.guid) {
          log.w(`#### NAVIGATE FROM : ${from.params.guid}`)
          log.w(`#### NAVIGATE TO   : ${to.params.guid}`)
          // TODO provide a global reinit of all forms vars to default
          this.isGuidNull = false
          this.isDemandeInitialeROLoaded = false
          this.step1IsDone = false
          this.isIdDemandeValid = false
          this.isGuidValid = false
          this.streetSelected = null
          if (!isNullOrUndefined(to.params.guid)) {
            demandePoDP.getDemandeInitiale(to.params.guid, (dataref) => {
              log.l('## IN viewPoDP.watch($route) callback for reloading of :' + to.params.guid)
              this.cacheInitialData(dataref)
            })
          } else {
            log.w('## IN viewPoDP.watch($route) to.params.guid is undefined !')
          }
        } else {
          log.w('## IN viewPoDP.watch($route) : NO NAVIGATION BECAUSE guid is the same')
          log.w(`#### NAVIGATE FROM : ${from.params.guid}`)
          log.w(`#### NAVIGATE TO   : ${to.params.guid}`)
        }
      }
    },
    created: function () {
      log.l('## INSIDE  goelandFormPodp created ')
      if (this.guid !== null) {
        this.isGuidNull = false
        demandePoDP.getDemandeInitiale(this.guid, (dataref) => {
          log.l('## INSIDE viewPoDP.getDemandeInitiale callback for created')
          this.cacheInitialData(dataref)
        })
      } else {
        log.w('## INSIDE  goelandFormPodp created : guid is null')
        this.isGuidNull = true
      }
    }, // end of created hook section

    mounted: function () {
      axios.get(`${BASE_REST_API_URL}/streets`)
      .then(resp => {
        // console.dir(resp)
        this.streetList = resp.data
      })
      .catch(err => {
        log.e('## ERROR IN Form mounted axios.get ', err)
      })
      log.l('## IN  goelandFormPodp mounted ')
      if (this.guid !== null) {
        if (demandePoDP.isDemandeCached(this.guid)) {
          this.cacheInitialData(demandePoDP.getDemandeInitiale(this.guid))
        }
      }
    }, // end of mounted hook section

    filters: {
      convertReturn2Comma: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace('\n', ', ')
      },
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      dateformat: function (value) {
        if (!value) return ''
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        const madate = new Date(value)
        return madate.toLocaleDateString('fr-CH', options)
      },
      dateTimeformat: function (value) {
        if (!value) return ''
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        const madate = new Date(value)
        return madate.toLocaleDateString('fr-CH', options) + ' à ' + madate.toLocaleTimeString('fr-CH')
      }
    },
    methods: {
      cacheInitialData (dataref) {
        log.l('## IN  goelandViewPodp.cacheInitialData ')
        if (typeof dataref === 'object') {
          try {
            this.data_json = JSON.parse(dataref['json_data'])
            this.demandeDataEnCours.guid = this.guid
            this.demandeDataEnCours.realGuid = dataref['guid']
            this.demandeInitialeRO.datecreated = dataref['datecreated']
            this.idDemande = this.data_json['IdAffaire']
            // lets's check if data was already saved
            demandePoDP.isDemandeAlreadysaved(this.idDemande, (data) => {
              log.l('## INSIDE demandePoDP.isDemandeAlreadysaved callback for done')
              this.isDemandeAlreadysaved = data // will be true or false
              this.getSubmitedData()
            })
            this.demandeInitialeRO.id = this.data_json['IdAffaire']
            this.demandeInitialeRO.nomAffaire = this.data_json['NomAffaire']
            this.demandeInitialeRO.responsableVdL = this.data_json['ResponsableVdL']
            this.demandeInitialeRO.itWasUnAuthorizedOccupacy = this.data_json['BRegularisation'] !== '0'
            this.demandeInitialeRO.BPayant = this.data_json['BPayant'] !== '0'
            // info du client a priori beneficiaire or acteur
            this.demandeDataEnCours.affClientContact = this.data_json['AffClientContact']
            this.demandeDataEnCours.affClientEmail = this.data_json['AffClientEmail']
            this.demandeDataEnCours.affClientTelephone = this.data_json['AffClientTelephone']
            // l'IDAFF "VDL-coordination chantier"
            this.demandeInitialeRO.IdAffCoordChantier = this.data_json['IdAffCoordChantier']
            this.demandeInitialeRO.nomAffCoordChantier = this.data_json['NomAffCoordChantier']
            this.demandeInitialeRO.UOLeaderAffCoordChantier = this.data_json['UOLeaderAffCoordChantier']
            if (this.demandeInitialeRO.IdAffCoordChantier) {
              // si on a un IdAffCoordChantier c'est que chantier vient de la Ville pas besoin de saisir MaitreOuvrage
              this.demandeInitialeRO.MaitreOuvrage.Role = 'Maitre d\'Ouvrage'
              this.demandeInitialeRO.MaitreOuvrage.Nom = this.demandeInitialeRO.UOLeaderAffCoordChantier
              this.demandeInitialeRO.isMaitreOuvrageGiven = true
              this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid = true
            }
            let arrRue = this.data_json['RueL']
            if (isNullOrUndefined(arrRue)) {
              log.e('La liste des RueL est absente de la demande initiale')
              this.isDemandeInitialeROLoaded = false
              this.isGuidValid = false
            }
            for (let i = 0; i < arrRue.length; i++) {
              this.goodStreetIds.push(arrRue[i]['IdRueL'])
            }
            // traitement acteur liés "ActeurL": [{...}]
            // on doit recevoir au moins 1 entree dans ActeurL roles possibles sont beneficiaire et mandataire
            let arrActeurLie = this.data_json['ActeurL']
            if (arrActeurLie.length > 1) {
              this.demandeInitialeRO.isBeneficiaireGiven = true
              this.demandeInitialeRO.isMandataireGiven = true
              this.demandeDataEnCours.acteurMandataire.isActeurValid = true
              this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true
              // si on a deux entrees on part du principe que c'est mandataire qui a fait demande
              // et on recherche lequel des deux entrees il s'agit
              if (arrActeurLie[0]['Role'] === 'Mandataire') {
                this.demandeInitialeRO.Mandataire = arrActeurLie[0]
                this.demandeInitialeRO.Beneficiaire = arrActeurLie[1]
              } else {
                this.demandeInitialeRO.Beneficiaire = arrActeurLie[0]
                this.demandeInitialeRO.Mandataire = arrActeurLie[1]
              }
            } else { // on a qu'un seul acteur lié
              if (arrActeurLie[0]['Role'] === 'Bénéficiaire') {
                this.demandeInitialeRO.isBeneficiaireGiven = true
                this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true
                this.demandeInitialeRO.Beneficiaire = arrActeurLie[0]
              } else {
                this.demandeInitialeRO.isMandataireGiven = true
                this.demandeDataEnCours.acteurMandataire.isActeurValid = true
                this.demandeInitialeRO.Mandataire = arrActeurLie[0]
              }
            }
            if (isNullOrUndefined(this.demandeDataEnCours.geometrieChantiersSaisie)) {
              // on active la barre edition par defaut car pas de geometrie a priori
              this.isPolygonAlreadyPresentInGoeland = false
              if (!isNullOrUndefined(this.data_json['GeomAffCoordChantier']['features'])) {
                let arrFeatures = this.data_json['GeomAffCoordChantier']['features']
                if (arrFeatures.length > 0) {
                  log.l(`## IN  goelandFormPodp.cacheInitialData found ${arrFeatures.length} features`, arrFeatures)
                  // on desactive la barre edition par defaut si la geometrie est fournie par coordination chantier
                  this.demandeInitialeRO.geomAffCoordChantier = arrFeatures[0].geometry
                  this.isPolygonAlreadyPresentInGoeland = true
                  // this.demandeDataEnCours.geometrieChantiersSaisie = arrFeatures[0].geometry
                }
              }
            }
            this.demandeDataEnCours.id = this.idDemande
            this.demandeDataEnCours.IdAffCoordChantier = this.demandeInitialeRO.IdAffCoordChantier
            this.demandeDataEnCours.datecreated = null
            // state management
            this.isDemandeInitialeROLoaded = true
            this.isGuidValid = true
            this.getSubmitedData()
          } catch (e) {
            log.e(`###  ERROR IN  goelandFormPodp.cacheInitialData while parsing json`, demandePoDP.lastError)
            this.demandeDataEnCours.realGuid = `## ERREUR ## pendant la lecture de la demande initiale en JSON: `
            this.demandeDataEnCours.realGuid += JSON.stringify(dataref)
            this.isDemandeInitialeROLoaded = false
            this.isGuidValid = false
          }
        } else {
          log.e(`###  ERROR IN  goelandFormPodp.cacheInitialData [${dataref}]`)
          log.e(`###  ERROR IN  goelandFormPodp.cacheInitialData : demandePoDP.lastError =`, demandePoDP.lastError)
          if (JSON.stringify(demandePoDP.lastError).indexOf('no records found') > 0) {
            this.demandeDataEnCours.realGuid = `## ERREUR ##  Aucune demande en cours avec pour cet identifiant !`
          } else {
            this.demandeDataEnCours.realGuid = `## ERREUR ##  [${JSON.stringify(demandePoDP.lastErrorMsg)}] !`
          }
          log.w(JSON.stringify(demandePoDP.lastError))
          log.e(demandePoDP.lastError)
          this.isDemandeInitialeROLoaded = false
          this.isGuidValid = false
        }
      }, // end of cacheInitialData
      submitForm (event) {
        if (this.isdemandeDataEnCoursLoaded || !this.isDemandeAlreadysaved) {
          log.l(`### IN  goelandFormPodp.submitForm `)
          if (this.isGuidValid) {
            this.demandeDataEnCours.isFinalSubmitDone = true
            let savedData = {
              id: this.idDemande,
              demandeDataEnCours: this.demandeDataEnCours
            }
            if (event) {
              if (functionExist(event.preventDefault)) event.preventDefault()
            }
            demandePoDP.submitDemande(this.demandeDataEnCours.realGuid, savedData, resp => {
              log.l('### IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp)
              if (JSON.stringify(resp).indexOf('ERROR') > 0) {
                log.e('### ERROR IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp)
                log.w('demandePoDP.lastError = ', demandePoDP.lastError)
                this.lastSavingError = `## ERREUR PENDANT L'ENVOI DU FORMULAIRE ! ## ${demandePoDP.lastErrorMsg} [${resp}] !`
                this.isSavingError = true
              } else {
                this.lastSavingError = ''
                this.isSavingError = false
                this.isSubmitToLocalDatabaseSuccessfull = true
                // pour indiquer correctement la date dans la confirmation vu que l'on a pas le retour de la bd mais que c'est sauve
                let todayDate = new Date()
                this.demandeDataEnCours.datesubmited = todayDate.toLocaleString('fr')
              }
            })
          } else {
            this.lastSavingError = `## IMPOSSIBLE D'ENVOYER CE FORMULAIRE ce guid est invalide : ${this.demandeDataEnCours.realGuid}] !`
            this.isSavingError = true
          }
        } else {
          log.w(`### IN  goelandFormPodp.submitForm NOT SAVING car isdemandeDataEnCoursLoaded est FAUX`)
        }
      },
      getSubmitedData () {
        log.l('## in goelandViewPodp.getSubmitedData isDemandeAlreadysaved = ', this.isDemandeAlreadysaved)
        this.step1IsDone = true
        this.isIdDemandeValid = true
        let that = this
        // a timer seems to be the only way to get it working
        window.setTimeout(function () {
          that.$refs.mapchantier.updateScreen()
        }, 1500)
        if (this.isDemandeAlreadysaved) {
          // let's get back the current data
          demandePoDP.getdemandeEnCours(this.idDemande, (dataref) => {
            log.l('##****** IN demandePoDP.getdemandeEnCours callback', dataref)
            if (typeof dataref === 'string') {
              log.w('## ERROR IN demandePoDP.getdemandeEnCours callback', dataref)
              this.isdemandeDataEnCoursLoaded = false
            } else {
              log.l('## IN demandePoDP.getdemandeEnCours before JSON.parse')
              this.demandeDataEnCours = JSON.parse(dataref['json_data'])
              this.demandeDataEnCours.datecreated = dataref['datecreated']
              this.demandeDataEnCours.datelastmodif = dataref['datelastmodif']
              this.demandeDataEnCours.datesubmited = dataref['datesubmited']
              log.l('## IN demandePoDP.getdemandeEnCours before geometrieChantiersSaisiePrecedement')
              this.geometrieChantiersSaisiePrecedement = this.demandeDataEnCours.geometrieChantiersSaisie
              if (!isNullOrUndefined(this.demandeDataEnCours.datesubmited)) {
                this.isSubmitToLocalDatabaseSuccessfull = true
              } else {
                // this.$refs.mapchantier.updateScreen()
              }
              this.isdemandeDataEnCoursLoaded = true
              log.l('## IN demandePoDP.getdemandeEnCours before JSON.stringify')
              // const tmpJsonData = JSON.stringify(getObjecSortedtbyKey(this.demandeDataEnCours), null, 2)
              const tmpJsonData = JSON.stringify(this.demandeDataEnCours, null, 2)
              log.l('## IN demandePoDP.getdemandeEnCours before setting jsonDemandeDataEnCours.innerHTML')
              // this.$refs.jsonDemandeDataEnCours.innerHTML = tmpJsonData
              log.l('##****** IN demandePoDP.getdemandeEnCours finished loading demandeDataEnCours', tmpJsonData)
            }
          })
        }
        // this.streetSelected = val.value
      },
      checkIsValidStreetId (idStreet) {
        if (((this.goodStreetIds.indexOf(idStreet)) > -1) &&
          this.demandeInitialeRO.id === this.idDemande) {
          log.l('##++ in goelandFormPodp.checkIsValidStreetId VALID idStreet:', idStreet)
          return true
        } else {
          log.l('##-- in goelandFormPodp.checkIsValidStreetId INVALID idStreet:', idStreet)
          return false
        }
      },
      saveGeometry: function (val) {
        log.l('##++ in goelandFormPodp.saveGeometry cgil-vue-olmap event gomapSaveGeomClick received : ', val)
        this.demandeDataEnCours.geometrieChantiersSaisie = val
      },
      adjustMap: function (val) {
        log.l('##++ in goelandFormPodp.adjustMap goCollapse event gocollapseOpen received : ', val)
        // 2018-05-03 cgil commented out next line because it breaks map display component when collapse is false and reveals underlying content
        // this.$refs.mapchantier.updateScreen()
        this.showMap = true
      }
    } // end of methods section
  }
</script>


<style lang="scss">


.fouille-legend{
  font-size: 16px;
  margin-bottom: 4px;
}
.fouille-fieldset{
  padding-top: 5px;
  padding-bottom: 5px;
}


  .goOccupationCheckbox{
    font-size: 1em;
  }

  /*
    $current_field_color: #1512e9;

    $base_size: 32px;
    * {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    /* default design for small device first */
  /*
    form {
      padding: ($base_size / 6);
      width: 100%;
      fieldset {
        width: 100%;
        text-align: left;
        div {
          margin-top: ($base_size / 6);
          input, select, textarea {
            width: 100%;
            font-size: 1em;
            &:focus {
              outline: 0;
              border-color: $current_field_color;
            }
          }
        }
      }
    }

    @media (min-width: 600px) {
      form {
        background-color: #5bc0de;
        font-size: 1.1em;
        fieldset {
          div {
            label {
              width: 40%;
              float: left;
              padding-right: 1em;
            }
            input, select, textarea {
              width: 60%;
              font-size: 1.2em;
            }
          }
        }
      }
    }

    @media (min-width: 1024px) {
      .form-container {
        width: 100%;
        padding: 1.2em 2em 1em 2em;
      }
      form {
        background-color: #c4e3f3;
        font-size: 1.1em;
        fieldset {
          div {
            display: inline-flex;
            width: 50%;
            float: left;
            label {
              text-align: right;
              width: 45%;
            }
            input, select, textarea{
              width: 55%;
            }



          }
        }
      }
    }
  */
</style>



// WEBPACK FOOTER //
// src/components/goelandViewPodp.vue